<template>
  <button type="button" class="btn-white">
    <i class="fa-solid fa-upload" />
    <span class="space-icon" />{{ label }}
  </button>
</template>

<script>
export default {
  name: "UploadButton",
  props: ["label"],
};
</script>